import Styles from '../Button/Button.module.scss'

interface ButtonProps {
  children?: any
  onClick?: () => void
  style?: React.CSSProperties
}
const Button: React.FC<ButtonProps> = ({ children, onClick, style }) => {
  return (
    <button className={Styles.button} style={style} onClick={onClick}>
      {children}
    </button>
  )
}
export { Button }
